import React from 'react';

const BlockedPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <h1 className="text-2xl font-bold text-red-600 mb-4">
        Access Blocked
      </h1>
      <p className="text-red-600">
        Your IP has been blocked due to too many failed attempts.
        Contact support if you think this is an error.
      </p>
    </div>
  );
};

export default BlockedPage;